import { z } from 'zod';

export const SeatmapDisplaySchema = z.object({
  enabled: z.boolean(),
  bestNode: z.boolean(),
});
